/**
 * Prepares a HBS template in the frontend.
 *
 * @param {HTMLElement} element
 */
export function loadHbstmpl(element) {
    var source = element.innerHTML;
    var key = element.getAttribute('data-ct-id');
    var sourcePrepped = eval('(function(){return ' + source + '}());'); // this is not nice but needed -.-
    Handlebars.partials[key] = Handlebars.template(sourcePrepped);
}
